import { DriverAssignmentFilter } from "../models"
import { signal } from "@angular/core"
import { ModalConfig } from "../../driver-management/driver-vehicle-assignment/models/vehicle-assignment.model"

export const BulkAssignmentModalConfig: ModalConfig = {
  mode: 'bulk',
  action: 'assign',
  assignmentFilter: {} as DriverAssignmentFilter,
  showConfirmationMessage: false,
  showConfirmationWarning: false,
  showDrivers: true,
  showSearch: true,
  showAssets: true,
  assetsLoaded: signal(false)
}

export const SingleAssignmentModalConfig: ModalConfig = {
  mode: 'single',
  action: 'assign',
  assignmentFilter: {} as DriverAssignmentFilter,
  showAssetFilter: true,
  showConfirmationMessage: false,
  showConfirmationWarning: false,
  showAssets: true,
  assetsLoaded: signal(false)
}

export const BulkUnAssignmentModalConfig: ModalConfig = {
  mode: 'bulk',
  action: 'unassign',
  assignmentFilter: {} as DriverAssignmentFilter,
  showConfirmationMessage: true,
  showConfirmationWarning: true,
  showAssetFilter: false,
  showDrivers: true,
  showSearch: true,
  showAssets: true,
  assetsLoaded: signal(false)
}

export const SingleUnAssignmentModalConfig: ModalConfig = {
  mode: 'single',
  action: 'unassign',
  showConfirmationMessage: true,
  showConfirmationWarning: true,
  showAssetFilter: false,
  assignmentFilter: {} as DriverAssignmentFilter,
  assetsLoaded: signal(false)
}